const baseUrl = 'profile';

export const ApiProfile = {
  Profile: baseUrl,
  ProfilePicture: `${baseUrl}/picture`,
  Contact: `${baseUrl}/contact`,
  Address: `${baseUrl}/address`,
  ProfileLinking: `${baseUrl}/linking`,
  ResendCode: `${baseUrl}/referral-code/send`,
  GetProfileByNric: (nric: string) => `${baseUrl}/nric/${nric}`,
  // BU-20810 / BU-20365 - existing-user migration steering
  MigrationStatus: `${baseUrl}/migration-status`,
  // BU-20814 / BU-20480 - eGiro autofill context for the currently-selected profile
  ActiveContext: `${baseUrl}/me/active-context`
};
